import { render, staticRenderFns } from "./AdminFiltersHeaderMenu.vue?vue&type=template&id=57a88628&scoped=true&"
import script from "./AdminFiltersHeaderMenu.vue?vue&type=script&lang=ts&"
export * from "./AdminFiltersHeaderMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a88628",
  null
  
)

export default component.exports